import React from 'react'
import styles from './styles.module.scss'
import htmr from 'htmr'

export type FlashBannerMessageProps = {
  messageDesktop: string
  messageMobile: string
  contentColor: string | null
}

function FlashBannerMessage({
  messageDesktop,
  messageMobile,
  contentColor
}: FlashBannerMessageProps) {
  return (
    <div
      className={styles.flashMsg}
      style={{ color: contentColor || undefined }}
    >
      <p className={styles.flashMsg__desktop}>{htmr(messageDesktop)}</p>
      <p className={styles.flashMsg__mobile}>{htmr(messageMobile)}</p>
    </div>
  )
}

export default FlashBannerMessage
